// import * as dayjs from "dayjs";

// TODO: ย้ายไปใช้ใน helper หน่อย
//===========================================================
// สร้างวันทั้งหมดจากข้อมูลที่กำหนด
export function populate_date({ day, start_time, end_time }, opening_periods) {
  let all_time_slot = [];

  opening_periods.map((opening_period) => {
    let date_start = opening_period.start_date_time
      .day(day)
      .hour(start_time.substring(0, 2))
      .minute(start_time.substring(3, 5));
    if (date_start < opening_period.start_date_time)
      date_start = date_start.add(7, "day");
    let date_end = date_start
      .hour(end_time.substring(0, 2))
      .minute(end_time.substring(3, 5));

    all_time_slot.push({
      start_date_time: date_start,
      end_date_time: date_end,
    });

    let valid = true;
    while (valid) {
      date_start = date_start.add(7, "day");
      date_end = date_end.add(7, "day");
      if (date_end > opening_period.end_date_time) {
        valid = false;
        break;
      }

      all_time_slot.push({
        start_date_time: date_start,
        end_date_time: date_end,
      });
    }
  });

  return all_time_slot;
}
//===========================================================
export function is_overlapse(a_start, a_end, b_start, b_end) {
  if (a_start.unix() > b_start.unix() && a_start.unix() < b_end.unix())
    return true;
  if (a_end.unix() > b_start.unix() && a_end.unix() < b_end.unix())
    return true;
  if (b_start.unix() > a_start.unix() && b_end.unix() < a_end.unix())
    return true;
  if (a_start.unix() == b_start.unix() || a_end.unix() == b_end.unix())
    return true;
  return false;
}
//===========================================================
export function is_set_overlapse(time_slot_set) {
  let result = false;
  for (let i = 0; i < time_slot_set.length; i++) {
    const element_i = time_slot_set[i];
    for (let j = i + 1; j < time_slot_set.length; j++) {
      const element_j = time_slot_set[j];
      const current_result = is_overlapse(
        element_i.start_date_time,
        element_i.end_date_time,
        element_j.start_date_time,
        element_j.end_date_time
      );
      result = result || current_result;
      if (result) return true;
    }
  }
  return result;
}
//===========================================================
